import { useState, useCallback, useEffect, useRef } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const useAdminData = ({ onUnauthorized, endpoint = "/api/admin/registrations" }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState("");

  const onUnauthorizedRef = useRef(onUnauthorized);
  onUnauthorizedRef.current = onUnauthorized;

  const fetchRows = useCallback(async () => {
    setLoading(true);
    setFetchError("");
    try {
      const res = await axios.get(`${API}${endpoint}`, { withCredentials: true });
      setRows(res.data);
    } catch (err) {
      if (err.response?.status === 401) {
        onUnauthorizedRef.current?.();
      } else {
        setFetchError("No se pudieron cargar los registros. Intenta de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  useEffect(() => {
    fetchRows();
  }, [fetchRows]);

  return { rows, loading, fetchError, fetchRows };
};
